import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from '../main-site/HomePage';
import Login from '../Login';
import AdminDashboard from '../admin/AdminDashboard';
import AttachType from '../admin/master/AttachType';
import BloodGroup from '../admin/master/BloodGroup';
import Category from '../admin/master/Category';
import State from '../admin/master/State';
import Taluka from '../admin/master/Taluka';
import District from '../admin/master/District';
import CityVillage from '../admin/master/CityVillage';
import GrantType from '../admin/master/GrantType';
import MotherTounge from '../admin/master/MotherTounge';
import Religion from '../admin/master/Religion';
import SchoolTimings from '../admin/master/SchoolTimings';
import Section from '../admin/master/Section';
import Standard from '../admin/master/Standard';
import StudentType from '../admin/master/StudentType';
import AddSchool from '../admin/school/AddSchool';
import PersonalDetailsPage from '../admin/student/PersonalDetailsPage';
import SchoolType from '../admin/master/SchoolType';
import Stream from '../admin/master/Stream';
import Caste from '../admin/master/Caste';
import SchoolContactAffiliationDetails from '../admin/school/SchoolContactAffiliationDetails';
import ViewSchoolData from '../admin/school/ViewSchoolData';
import ManageAdmin from '../admin/administrator/ManageAdmin';
import StudentRegistration from '../admin/student/StudentRegistration';
import SchoolDetailsPage from '../admin/school/SchoolDetailsPage';
import AdminOperatorDashboard from '../adminoperator/AdminOperatorDashboard';
import LeavingCertificate from '../reports/LeavingCertificate';
import SessionMaster from '../admin/master/SessionMaster';
import Profile from '../common/Profile';
import Report from '../reports/Report';
import BonafideCertificateEnglish from '../reports/BonafideCertificateEnglish';
import FormCertificate_15 from '../reports/FormCertificate_15';
import Attempt_Certificate from '../reports/Attempt_Certificate';
import Nirgam_Utara from '../reports/Nirgam_Utara';
import StudentDashboard from '../student/StudentDashboard';
import StudentPersonalDetailsLandingPage from '../student/StudentPersonalDetailsLandingPage';
import StudentProfile from '../student/StudentProfile';
import LeavingCertificatePreview from '../reports/LeavingCertificatePreview';
import SubjectMaster from '../admin/master/SubjectMaster';
import ReceptionistDashboard from '../receptionist/ReceptionistDashboard';
import ManageInquiry from '../receptionist/ManageInquiry';
import TeacherDetailsPage from '../admin/teacher/new-teacher/TeacherDetailsPage';
import TeachersLandingPage from '../teacher/TeachersLandingPage';
import SaralImportReport from '../reports/SaralImportReport';
import SaralProfileUpdationReport from '../reports/SaralProfileUpdationReport';
import UDISEImportReport from '../reports/UDISEImportReport';
import UDISEProfileUpdationReport from '../reports/UDISEProfileUpdationReport';
import ApaarIdReport from '../reports/ApaarIdReport';
import AadhaarReport from '../reports/AadhaarReport';
import GenderwiseReport from '../reports/GenderwiseReport';
import BoardWiseReport from '../reports/BoardWiseReport';
import CategoryWiseReport from '../reports/CategoryWiseReport';
import AdmissionSourceReport from '../reports/AdmissionSourceReport';
import SchoolSessionMapping from '../admin/master/SchoolSessionMapping';
import TeacherClassSubjectMappingPage from '../admin/teacher/class-subject-mapping/TeacherClassSubjectMappingPage';
import ExamHeadDashboard from '../examhead/ExamHeadDashboard';
import MarkMaster from '../examhead/MarkMaster';
import GradeMaster from '../examhead/GradeMaster';
import MarkSFeedingPage from '../teacher/MarkSFeedingPage';
import ViewMarksFeeding from '../teacher/ViewMarksFeeding';
import LeavingCertificateOLPreview from '../reports/LeavingCertificateOLPreview';
import LeavingCertificateOL from '../reports/LeavingCertificateOL';
import ApproveEditMarks from '../examhead/ApproveEditMarks';
import ReportCard from '../teacher/ReportCard';
import ReportCardPrint from '../teacher/report-card/ReportCardPrint';
import SubjectCategoryMaster from '../admin/master/SubjectCategoryMaster';
import SubjectCategoryConfigMaster from '../admin/master/SubjectCategoryConfigMaster';
import NumbermappingMaster from '../teacher/NumbermappingMaster';
import AttendanceReport from '../reports/AttendanceReport.jsx';
import AttendanceMaster from '../teacher/AttendanceMaster.jsx';
import ViewAttendance from '../teacher/ViewAttendance.jsx';
import DisabilityTypesMaster from '../admin/master/DisabilityTypesMaster.jsx';
import LCMaster from '../admin/master/LCMasters.jsx';
import BonafideReasonMaster from '../admin/master/BonafideReasonMaster.jsx';
import HolidayMaster from '../admin/master/HolidayMaster.jsx';
import StudentLCDetailMappings from '../teacher/StudentLCDetailMappings.jsx';
import EarlyReleaseRemarkMaster from '../admin/master/EarlyReleaseRemarkMaster.jsx';
import LCTrackingReport from '../reports/LCTrackingReport.jsx';
import SummaryReport from '../reports/SummaryReport.jsx';
import GraceMarksFeeding from '../reports/GraceMarksFeeding.jsx';
import ResultSummaryReport from '../reports/ResultSummaryReport.jsx';
import NewUserRegistration from '../NewUserRegistration.jsx';
import OverallAnnualExamReport from '../teacher/OverallAnnualExamReport.jsx';
import CategoryWiseAnnualExamReport from '../teacher/CategoryWiseAnnualExamReport.jsx';
import SubjectAndTeacherWiseAnnualExamReport from '../teacher/SubjectAndTeacherWiseAnnualExamReport.jsx';

const RouterPage = () => {
  return (
    <Router>
      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registration" element={<StudentRegistration />} />
        <Route path="/user-registration" element={<NewUserRegistration />} />

        {/* Superadmin */}
        <Route path="/superadmindashboard" element={<AdminDashboard />} />
        <Route path="/add-school" element={<AddSchool />} />
        <Route path="/manage-admin" element={<ManageAdmin />} />

        {/* Admin */}
        <Route path="/admindashboard" element={<AdminOperatorDashboard />} />
        <Route path="/school-list" element={<SchoolDetailsPage />} />
        <Route path="/add-school-contact-affiliation" element={<SchoolContactAffiliationDetails />} />
        <Route path="/school-details" element={<ViewSchoolData />} />
        <Route path="/manage-student" element={<PersonalDetailsPage />} />
        <Route path="/manage-inquiry" element={<ManageInquiry />} />

        {/* Reception */}
        <Route path="/manage-reception-dashboard" element={<ReceptionistDashboard />} />
        {/* <Route path="/manage-reception-dashboard" element={<ReceptionistDashboard />} /> */}

        {/* Reports */}
        <Route path="/leaving-certificate-preview/:studentId/:currentVersion/:currentCertificateNumber/:certificateId" element={<LeavingCertificatePreview />} />
        <Route path="/leaving-certificate/:studentId/:currentVersion/:currentCertificateNumber/:certificateId" element={<LeavingCertificate />} />

        <Route path="/leaving-certificateol-preview/:studentId/:currentVersion/:currentCertificateNumber/:certificateId" element={<LeavingCertificateOLPreview />} />
        <Route path="/leaving-certificateol/:studentId/:currentVersion/:currentCertificateNumber/:certificateId" element={<LeavingCertificateOL />} />

        <Route path="/bonafide-certificate/:studentId/:currentCertificateNumber/:certificateId/:reasonId" element={<BonafideCertificateEnglish />} />
        <Route path="/form15/:studentId" element={<FormCertificate_15 />} />
        <Route path="/attempt-certificate/:studentId" element={<Attempt_Certificate />} />
        <Route path="/nirgam-utara-certificate/:studentId" element={<Nirgam_Utara />} />

        {/* Student */}
        <Route path="/studentdashboard" element={<StudentDashboard />} />
        <Route path="/manage-personal-student" element={<StudentPersonalDetailsLandingPage />} />
        <Route path="/student-profile" element={<StudentProfile />} />

        {/* Teacher */}
        <Route path="/manage-teachers" element={<TeacherDetailsPage />} />
        <Route path="/teachers-landing" element={<TeachersLandingPage />} />
        <Route path="/student-profile" element={<StudentProfile />} />
        <Route path="/teacher-class-subject-mapping" element={<TeacherClassSubjectMappingPage />} />
        <Route path="/manage-marks-feeding" element={<MarkSFeedingPage />} />
        <Route path="/summary-report" element={<SummaryReport />} />
        <Route path="/result-summary-report" element={<ResultSummaryReport />} />
        <Route path="/grace-marks-feeding" element={<GraceMarksFeeding />} />
        <Route path="/view-marks-feeding" element={<ViewMarksFeeding />} />
        <Route path="/report-card" element={<ReportCard />} />
        <Route path="/overall-annual-exam-report" element={<OverallAnnualExamReport />} />
        <Route path="/category-wise-annual-exam-report" element={<CategoryWiseAnnualExamReport />} />
        <Route path="/subject-and-teacher-wise-annual-exam-report" element={<SubjectAndTeacherWiseAnnualExamReport />} />
        {/* <Route path="/report-card" element={<ReportCard />} /> */}
        {/* <Route path="/report-card-print/:studentId/:examType/:sessionId" element={<ReportCardPrint />} /> */}
        <Route path="/report-card-print/:studentId/:sessionId" element={<ReportCardPrint />} />
        <Route path="/number-mapping-master" element={<NumbermappingMaster />} />
        <Route path="/attendance-report" element={<AttendanceReport />} />
        <Route path="/mark-attendance" element={<AttendanceMaster />} />
        <Route path="/mark-lc-details-mappings" element={<StudentLCDetailMappings />} />
        <Route path="/view-attendance" element={<ViewAttendance />} />

        {/* Masters */}
        <Route path="/manage-attach-type" element={<AttachType />} />
        <Route path="/manage-blood-group" element={<BloodGroup />} />
        <Route path="/manage-category" element={<Category />} />
        <Route path="/manage-city" element={<CityVillage />} />
        <Route path="/manage-state" element={<State />} />
        <Route path="/manage-taluka" element={<Taluka />} />
        <Route path="/manage-district" element={<District />} />
        <Route path="/manage-grant-type" element={<GrantType />} />
        <Route path="/manage-monther-tounge" element={<MotherTounge />} />
        <Route path="/manage-religion" element={<Religion />} />
        <Route path="/manage-school-timing" element={<SchoolTimings />} />
        <Route path="/manage-school-type" element={<SchoolType />} />
        <Route path="/manage-section" element={<Section />} />
        <Route path="/manage-stream" element={<Stream />} />
        <Route path="/manage-standard" element={<Standard />} />
        <Route path="/manage-student-type" element={<StudentType />} />
        <Route path="/manage-caste" element={<Caste />} />
        <Route path="/manage-session" element={<SessionMaster />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/manage-subject" element={<SubjectMaster />} />
        <Route path="/manage-subject-category-master" element={<SubjectCategoryMaster />} />
        <Route path="/manage-subject-category-config" element={<SubjectCategoryConfigMaster />} />
        <Route path="/manage-school-session-mapping" element={<SchoolSessionMapping />} />
        <Route path="/manage-disability-master" element={<DisabilityTypesMaster />} />
        <Route path="/manage-bonafide-reason-master" element={<BonafideReasonMaster />} />
        <Route path="/manage-holiday-master" element={<HolidayMaster />} />
        <Route
          path="/manage-conduct-master"
          element={<LCMaster type="LCConductMaster" title="LC Conduct Master" />}
        />

        <Route
          path="/manage-progress-master"
          element={<LCMaster type="LCProgressMaster" title="LC Progress Master" />}
        />

        <Route
          path="/manage-remark-master"
          element={<LCMaster type="LCRemarkMaster" title="LC Remark Master" />}
        />

        <Route
          path="/manage-reason-master"
          element={<LCMaster type="LCReasonMaster" title="LC Reason Master" />}
        />

        <Route path="/manage-reports" element={<Report />} />
        <Route path="/manage-SaralImportReport" element={<SaralImportReport />} />
        <Route path="/manage-SaralProfileUpdationReport" element={<SaralProfileUpdationReport />} />
        <Route path="/manage-UDISEImportReport" element={<UDISEImportReport />} />
        <Route path="/manage-UDISEProfileUpdationReport" element={<UDISEProfileUpdationReport />} />
        <Route path="/manage-ApaarIdReport" element={<ApaarIdReport />} />
        <Route path="/manage-AadhaarReport" element={<AadhaarReport />} />
        <Route path="/manage-GenderwiseReport" element={<GenderwiseReport />} />
        <Route path="/manage-CategoryWiseReport" element={<CategoryWiseReport />} />
        <Route path="/manage-BoardWiseReport" element={<BoardWiseReport />} />
        <Route path="/manage-AdmissionSourceReport" element={<AdmissionSourceReport />} />

        {/* Exam Head */}
        <Route path="/examhead-landing" element={<ExamHeadDashboard />} />
        <Route path="/mark-master" element={<MarkMaster />} />
        <Route path="/grade-master" element={<GradeMaster />} />
        <Route path="/approve-edit-marks-request" element={<ApproveEditMarks />} />

        <Route path="/manage-early-remarks-master" element={<EarlyReleaseRemarkMaster />} />
        <Route path="/lc-tracking-master" element={<LCTrackingReport />} />

        {/* <Route path="*" element={<PageNotFound />} /> */}
      </Routes>
    </Router>
  );
};

export default RouterPage;
